import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Address from "./components/address/Address";
import Home from "./components/home/Home";
import Footer from "./components/footer/Footer";
import BuffetPricing from "./components/buffetPricing/BuffetPricing";
import Signup from "./components/signUp/signup";
import Rewards from "./components/rewards/Rewards";
import Login from "./components/login/login";
import Profile from "./components/profile/Profile";
import Drinks from "./components/drinks/Drinks";
import Gallery from "./components/gallery/Gallery";
import FAQ from "./components/FAQ/FAQ";
import ScrollToTop from "./components/ScrollToTop";
import BuffetDashPage from "./pages/BuffetDashPage";
import ClosureUpdate from "./components/ClosureUpdate/ClosureUpdate";

import "bootstrap/dist/css/bootstrap.min.css";

import "../src/App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/address" element={<Address />} /> {}
          <Route path="/buffet-pricing" element={<BuffetPricing />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/drinks" element={<Drinks />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/arcade/buffet-dash" element={<BuffetDashPage />} />
          <Route path="/closure-update" element={<ClosureUpdate />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
